import { Divider } from 'antd';
import React, { useState } from 'react';
import { MAX_BROWSER_WIDTH, MIN_BROWSWER_WIDTH } from '../../glossary/BusinessGlossaryPage';
import { ProfileSidebarResizer } from '../../entity/shared/containers/profile/sidebar/ProfileSidebarResizer';
import { SidebarWrapper } from '../../shared/sidebar/components';
import DomainNavigator from './domainNavigator/DomainNavigator';
import DomainSearch from '../DomainSearch';

export default function ManageDomainsSidebar() {
    const [browserWidth, setBrowserWith] = useState(250);

    return (
        <>
            <SidebarWrapper width={browserWidth} className="f-width-100-xs f-mb-2-xs">
                <DomainSearch />
                <Divider className="ma-0" />
                <DomainNavigator />
            </SidebarWrapper>
            <ProfileSidebarResizer
                setSidePanelWidth={(width) =>
                    setBrowserWith(Math.min(Math.max(width, MIN_BROWSWER_WIDTH), MAX_BROWSER_WIDTH))
                }
                initialSize={browserWidth}
                isSidebarOnLeft
            />
        </>
    );
}
